<template>
  <div class="sidebar-left">
    <div class="sidebar-body scroll-pane">

      <div class="side-nav">
        <v-collapse accordion>
          <v-collapse-item v-if="arrayBarra[0]['state'] === true || arrayBarra[1]['state'] === true"  active-url="/admin/dashboard">
            <a slot="item-title" href="#">
              <i class="icon-fa icon-fa-line-chart" />Panel de control
              <span class="icon-fa arrow icon-fa-fw" />
            </a>
            <router-link to="/admin/menu" v-if="arrayBarra[0]['state'] === true"
            ><i class="icon-fa icon-fa-bars" />Menú</router-link
            ><!--
            <router-link to="/admin/dashboard/basic" v-if="arrayBarra[1]['state'] === true"
            ><i class="icon-fa icon-fa-bar-chart" />Gráficos</router-link
            > -->
          </v-collapse-item>

          <v-collapse-item v-if="arrayBarra[2]['state'] === true || arrayBarra[3]['state'] === true || arrayBarra[4]['state'] === true || arrayBarra[5]['state'] === true || arrayBarra[6]['state'] === true" active-url="/admin/account">
            <a slot="item-title" href="#">
              <i class="icon-fa icon-fa-bank" />Cuentas
              <span class="icon-fa arrow icon-fa-fw" />
            </a>
            <router-link v-if="arrayBarra[2]['state'] === true" to="/admin/cuentas"><i class="icon-fa icon-fa-money"/>Cuenta</router-link>
            <router-link v-if="arrayBarra[3]['state'] === true" to="/admin/cajas"><i class="icon-fa icon-fa-inbox"/>Cajas</router-link>
            <router-link v-if="arrayBarra[4]['state'] === true" to="/admin/transacciones"><i class="icon-fa icon-fa-exchange"/>Transacciones</router-link>
            <router-link v-if="arrayBarra[5]['state'] === true"
              to="/admin/cuentasporcobrar/lista">
              <i class="icon-fa icon-fa-sign-in" />Cuentas por cobrar
            </router-link>
            <router-link v-if="arrayBarra[6]['state'] === true"
              to="/admin/cuentasporpagar/lista">
              <i class="icon-fa icon-fa-sign-out" />Cuentas por pagar
            </router-link>
            <!-- <router-link to="/admin/pdfprueba"><i class="icon-fa icon-fa-check"/>PDF de prueba</router-link> -->
          </v-collapse-item>

          <v-collapse-item v-if="arrayBarra[7]['state'] === true || arrayBarra[8]['state'] === true || arrayBarra[9]['state'] === true" active-url="/admin/dashboard">
            <a slot="item-title" href="#">
              <i class="icon-fa icon-fa-product-hunt" />Productos
              <span class="icon-fa arrow icon-fa-fw" />
            </a>
            <router-link v-if="arrayBarra[9]['state'] === true" to="/admin/products/productos"><i class="icon-fa icon-fa-barcode"/>Productos</router-link>
          </v-collapse-item>

          <v-collapse-item v-if="arrayBarra[10]['state'] === true || arrayBarra[11]['state'] === true || arrayBarra[12]['state'] === true" active-url="/admin/dashboard">
            <a slot="item-title" href="#">
              <i class="icon-fa icon-fa-users" />Personal
              <span class="icon-fa arrow icon-fa-fw" />
            </a>
            <router-link v-if="arrayBarra[10]['state'] === true" to="/admin/personas/empleados"
            ><i class="icon-fa icon-fa-user" />Empleados</router-link
            >
            <router-link v-if="arrayBarra[11]['state'] === true" to="/admin/personas/usuarios"
            ><i class="icon-fa icon-fa-user-plus"/>Usuarios</router-link
            >
            <router-link v-if="arrayBarra[12]['state'] === true" to="/admin/personas/roles"
            ><i class="icon-fa icon-fa-user-secret"/>Roles</router-link
            >
          </v-collapse-item>

          <v-collapse-item v-if="arrayBarra[13]['state'] === true || arrayBarra[14]['state'] === true || arrayBarra[15]['state'] === true || arrayBarra[16]['state'] === true" active-url="/admin/dashboard">
            <a slot="item-title" href="#">
              <i class="icon-fa icon-fa-shopping-cart" />Ventas
              <span class="icon-fa arrow icon-fa-fw" />
            </a>
            <router-link v-if="arrayBarra[13]['state'] === true" to="/admin/venta/lista"
            ><i class="icon-fa icon-fa-th-list" />Listado de ventas</router-link
            >
            <router-link v-if="arrayBarra[14]['state'] === true" to="/admin/venta/nuevo"
            ><i class="icon-fa icon-fa-cart-plus" />Nueva venta</router-link
            >
            <router-link v-if="arrayBarra[15]['state'] === true" to="/admin/venta/documentos"
            ><i class="icon-fa icon-fa-file" />Documentos</router-link
            >
            <router-link v-if="arrayBarra[16]['state'] === true" to="/admin/personas/clientes"
            ><i class="icon-fa icon-fa-user" />Clientes</router-link
            >
          </v-collapse-item>

          <v-collapse-item v-if="arrayBarra[17]['state'] === true || arrayBarra[18]['state'] === true || arrayBarra[19]['state'] === true" active-url="/admin/dashboard">
            <a slot="item-title" href="#">
              <i class="icon-fa icon-fa-shopping-basket" />Compras
              <span class="icon-fa arrow icon-fa-fw" />
            </a>
            <router-link v-if="arrayBarra[17]['state'] === true" to="/admin/compra/lista"
            ><i class="icon-fa icon-fa-th-list" />Listado de compras</router-link
            >
            <router-link v-if="arrayBarra[18]['state'] === true" to="/admin/compra/nuevo"
            ><i class="icon-fa icon-fa-cart-plus" />Nueva compra</router-link
            >
            <router-link v-if="arrayBarra[19]['state'] === true" to="/admin/personas/proveedores"
            ><i class="icon-fa icon-fa-user" />Proveedores</router-link
            >
          </v-collapse-item>

          <v-collapse-item v-if="arrayBarra[20]['state'] === true || arrayBarra[21]['state'] === true || arrayBarra[22]['state'] === true" active-url="/admin/dashboard">
            <a slot="item-title" href="#">
              <i class="icon-fa icon-fa-dropbox" />Bodega
              <span class="icon-fa arrow icon-fa-fw" />
            </a>
            <router-link v-if="arrayBarra[20]['state'] === true" to="/admin/bodega/entrada"
            ><i class="icon-fa icon-fa-sign-in" />Entrada de producto</router-link
            >
            <router-link v-if="arrayBarra[21]['state'] === true" to="/admin/bodega/salida"
            ><i class="icon-fa icon-fa-sign-out" />Salida de producto</router-link
            >
            <!-- <router-link v-if="arrayBarra[22]['state'] === true" to="/admin/productos/transporte"><i class="icon-fa icon-fa-car"/>Trasladar producto</router-link> -->
          </v-collapse-item>

          <v-collapse-item v-if="arrayBarra[23]['state'] === true" active-url="/admin/ajuste">
            <a slot="item-title" href="#">
              <i class="icon-fa icon-fa-cogs" />Ajustes
              <span class="icon-fa arrow icon-fa-fw" />

            </a>
            <router-link v-if="arrayBarra[23]['state'] === true" to="/admin/productos/localidades"><i class="icon-fa icon-fa-flag"/>Localidades</router-link>
          </v-collapse-item>

          <v-collapse-item v-if="arrayBarra[24]['state'] === true" active-url="/admin/dashboard">

            <router-link slot="item-title" to="/admin/reports"><i class="icon-fa icon-fa-file-text"/>Reportes</router-link>
          </v-collapse-item>

        </v-collapse>
      </div>
    </div>
  </div>
</template>

<script>
// import Auth from '../../services/auth' <--- este es el helper para traer los datos del localStorage
import ladda from 'ladda'
import Ls from '../../../services/ls'

export default {
  data () {
    return {
      arrayPermisos: null,
      arrayBarra: [
        { id: 1, state: false},
        { id: 2, state: false},
        { id: 3, state: false},
        { id: 7, state: false},
        { id: 11, state: false},
        { id: 16, state: false},
        { id: 17, state: false},
        { id: 18, state: false},
        { id: 22, state: false},
        { id: 30, state: false},
        { id: 39, state: false},
        { id: 52, state: false},
        { id: 56, state: false},
        { id: 62, state: false},
        { id: 63, state: false},
        { id: 73, state: false},
        { id: 77, state: false},
        { id: 81, state: false},
        { id: 82, state: false},
        { id: 90, state: false},
        { id: 94, state: false},
        { id: 95, state: false},
        { id: 96, state: false},
        { id: 99, state: false},
        { id: 103, state: false},
      ]
    }
  },
  validations: {

  },
  methods: {
    validarPermisos () {
      // Aqui extraer los permisos de la SiteBar
      this.arrayPermisos = JSON.parse(Ls.get('auth.roles'))
      //trabajar con idpermits
      for (let i = 0; i < this.arrayPermisos.length; i++) {

        for (let j = 0; j < this.arrayBarra.length; j++){
          if(this.arrayPermisos[i]['idpermits'] === this.arrayBarra[j]['id'] && this.arrayPermisos[i]['state'] === 1){
            this.arrayBarra[j]['state'] = true;
          }
        }

      }
    },
  },
  mounted() {
    this.validarPermisos()
  }
}
</script>
<style>
.letra {
  font-family: 'Poppins', sans-serif;
}
</style>



// WEBPACK FOOTER //
// resources/js/views/layouts/partials/TheSiteSidebar.vue